import tracking from 'src/middleware/tracking';
import router from 'src/middleware/router';
import context from 'src/middleware/context';
import reducers from 'src/modules/shared/reducers';
import pagesReducers from 'src/modules/pageReducers';
import modalsReducers from 'src/modules/shared/modal/modalsReducers';

// LIB
import thunkMiddleware from 'redux-thunk';

// REDUX
import { applyMiddleware, combineReducers, createStore, compose } from 'redux';

// TODO move this into pages/_app.js (which we'll need to create
// once we've upgraded our nextjs version to one that supports a custom App.
import * as logging from 'config/logging';
logging.configure();

const middleware = [
  thunkMiddleware,
  context,
  router,
  tracking,
];

const composeEnhancers = typeof window != 'undefined'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const initStore = (initialState = {}) => {
  return createStore(
    combineReducers({
      ...reducers,
      modals: combineReducers({
        ...modalsReducers,
      }),
      pages: combineReducers({
        ...pagesReducers,
      }),
    }),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
    ),
  );
};

